import React from "react";
import usePrep from "../../components/usePrep";
import { ErrorBox, Loader, TrainingIcon, safeUrl } from "../../components/PortalBits";

function LiveTrainings() {
  const { loading, error, items, reload } = usePrep();
  const sessions = items.flatMap((i) => (i.live_trainings || []).map((s) => ({ ...s, exam_code: i.exam_code })));
  const codes = items.map((i) => i.exam_code).join(", ");

  return (
    <div className="panel">
      <h2>Upcoming Live Trainings</h2>
      <div className="sub">Instructor-led sessions to help you prepare{codes ? ` for ${codes}` : ""}.</div>
      {loading && <Loader />}
      {!loading && error && <ErrorBox message={error} onRetry={reload} />}
      {!loading && !error && sessions.length === 0 && (
        <div className="empty-state">No live trainings are scheduled right now. New sessions will appear here.</div>
      )}
      {sessions.map((s, i) => {
        const url = safeUrl(s.enroll_url);
        return (
          <div key={`${s.exam_code}-${i}`} className="training-card">
            <TrainingIcon />
            <div className="training-body">
              <div className="training-title">{s.title}</div>
              <div className="training-tag">{s.tag || `${s.exam_code} virtual training`}</div>
              {s.dates && <div className="training-line">Dates: <b>{s.dates}</b></div>}
              {s.time && <div className="training-line">Time: <b>{s.time}</b></div>}
              {s.mode && <div className="training-line">Mode: <b>{s.mode}</b></div>}
              {s.promo && <div className="training-promo">{s.promo}</div>}
              {url && (
                <a className="btn btn-primary" style={{ marginTop: 14 }} href={url} target="_blank" rel="noopener noreferrer">
                  Enroll now
                </a>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default LiveTrainings;
